<template>
  <div id="app">
    <Layout />
    <AIAbility ref="AIAbility" v-if="routeName1.includes($route.name) && subscribeKit" />
    <!-- &&subscribeKit -->
    <el-dialog :visible.sync="visible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false"
      width="480px" class="user-visible">
      <div slot="title" style="display: flex; align-items: center">
        <i class="el-icon-warning" style="font-size: 24px; margin-right: 6px; color: #ff9a3e"></i>
        <span>提示</span>
      </div>
      <span>当前用户信息已刷新,是否立即更新?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Layout from "@/components/layout.vue";
import AIAbility from "@/components/intellect-marketing/mailDetail/AIAbility";
import { getSearchPermission } from "@/utils/api/permission-verification.js";
import { getUserInfo } from "@/utils/api";

export default {
  data() {
    return {
      routeName: ["mail-list", "statistics", "created-mail", "mail-detail"],
      routeName1: ["dashboard"],
      subscribeKit: false,
      visible: false,
    };
  },
  components: {
    Layout,
    AIAbility,
  },
  methods: {
    // 重新请求会员信息
    async requestAccessData() {
      try {
        const res = await getSearchPermission();
        if (res.rspResult.bizCode === 200) {
          this.subscribeKit = res.data.subscribeKit;
          console.log(this.subscribeKit);
          this.$store.commit(
            "permissionVerification/SET_ACCESS_DATA",
            res.data
          );
          this.$store.commit("SET_SUBSCRIBEKIT", res.data.subscribeKit);
          this.$store.commit(
            "SET_HISTORYSUBSCRIBEKIT",
            res.data.historySubscribeKit
          );
        } else {
          this.subscribeKit = false;
          this.$store.commit("permissionVerification/SET_ACCESS_DATA", null);
        }
      } catch (err) {
        this.subscribeKit = false;
        console.error(
          "❌ ~ file: permissionVerification.js:21 ~ requestAccessData ~ err:",
          err
        );
        this.$store.commit("permissionVerification/SET_ACCESS_DATA", null);
      }
    },
    onConfirm() {
      this.visible = false;
      window.location.reload();
    },
  },
  mounted() {
    this.requestAccessData();
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        getUserInfo().then((res) => {
          if (res.rspResult.bizCode === 200) {
            if (
              this.$store.state.userInfo.userId &&
              this.$store.state.userInfo.userId !== res.data.userId
            ) {
              if (!this.visible) {
                this.visible = true;
              }
            } else {
              if (this.visible) {
                this.visible = false;
              }
            }
          }
        });
        // 这里可以执行页面重新激活时的逻辑
      } else if (document.visibilityState === "hidden") {
        // 这里可以执行页面非活动时的逻辑
      }
    });
  },
  beforeDestroy() {
    // 清除监听器
    document.removeEventListener("visibilitychange", () => { });
  },
};
</script>

<style lang="scss" scoped>
::v-deep .user-visible {
  .el-dialog {
    padding: 10px;
    border-radius: 8px;

    .el-dialog__body {
      padding: 10px 20px 20px;
    }
  }
}
</style>
